import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { renameGabarit, deleteGabarit } from "state/gabarit/actions";
import { faPen, faTrash, faCheck, faTimes } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import swal from "sweetalert";
import { css } from "emotion";

const GabaritItem = ({ gabarit, onSelect, isSelected }) => {
  const dispatch = useDispatch();
  const [isEditing, setIsEditing] = useState(false);
  const [editName, setEditName] = useState(gabarit.name);

  const handleRename = () => {
    if (editName.trim() && editName !== gabarit.name) {
      dispatch(renameGabarit(gabarit.id, editName.trim()));
    }
    setIsEditing(false);
  };

  const handleDelete = (e) => {
    e.stopPropagation();
    swal({
      title: "Supprimer ce gabarit ?",
      text: `Le gabarit "${gabarit.name}" sera supprimé définitivement.`,
      icon: "warning",
      buttons: ["Annuler", "Supprimer"],
      dangerMode: true,
    }).then((confirm) => {
      if (confirm) {
        dispatch(deleteGabarit(gabarit.id));
      }
    });
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter") {
      handleRename();
    }
    if (e.key === "Escape") {
      setEditName(gabarit.name);
      setIsEditing(false);
    }
  };

  return (
    <div
      className={css(styles.item, isSelected && styles.itemSelected)}
      onClick={() => !isEditing && onSelect(gabarit)}
    >
      {isEditing ? (
        <div className={css(styles.editRow)}>
          <input
            type="text"
            value={editName}
            onChange={(e) => setEditName(e.target.value)}
            onKeyDown={handleKeyDown}
            className={css(styles.editInput)}
            autoFocus
            onClick={(e) => e.stopPropagation()}
          />
          <button
            className={css(styles.iconBtn, styles.iconBtnSuccess)}
            onClick={(e) => {
              e.stopPropagation();
              handleRename();
            }}
            title="Valider"
          >
            <FontAwesomeIcon icon={faCheck} />
          </button>
          <button
            className={css(styles.iconBtn, styles.iconBtnDanger)}
            onClick={(e) => {
              e.stopPropagation();
              setEditName(gabarit.name);
              setIsEditing(false);
            }}
            title="Annuler"
          >
            <FontAwesomeIcon icon={faTimes} />
          </button>
        </div>
      ) : (
        <div className={css(styles.row)}>
          <span className={css(styles.name)}>{gabarit.name}</span>
          <div className={css(styles.actions)}>
            <button
              className={css(styles.iconBtn)}
              onClick={(e) => {
                e.stopPropagation();
                setIsEditing(true);
              }}
              title="Renommer"
            >
              <FontAwesomeIcon icon={faPen} size="sm" />
            </button>
            <button
              className={css(styles.iconBtn, styles.iconBtnDanger)}
              onClick={handleDelete}
              title="Supprimer"
            >
              <FontAwesomeIcon icon={faTrash} size="sm" />
            </button>
          </div>
        </div>
      )}
    </div>
  );
};

const styles = {
  item: {
    padding: "8px 12px",
    cursor: "pointer",
    borderBottom: "1px solid #eee",
    transition: "background-color 0.15s",
    ":hover": {
      backgroundColor: "#f0f9f1",
    },
  },
  itemSelected: {
    backgroundColor: "#e8f5e9",
    fontWeight: "bold",
  },
  row: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  editRow: {
    display: "flex",
    alignItems: "center",
    gap: "6px",
  },
  name: {
    flex: 1,
    overflow: "hidden",
    textOverflow: "ellipsis",
    whiteSpace: "nowrap",
    fontSize: "14px",
  },
  actions: {
    display: "flex",
    gap: "4px",
    marginLeft: "8px",
  },
  iconBtn: {
    background: "none",
    border: "none",
    cursor: "pointer",
    padding: "4px 6px",
    borderRadius: "4px",
    color: "#666",
    ":hover": {
      backgroundColor: "#e0e0e0",
    },
  },
  iconBtnSuccess: {
    color: "#579862",
    ":hover": {
      backgroundColor: "#e8f5e9",
    },
  },
  iconBtnDanger: {
    color: "#d32f2f",
    ":hover": {
      backgroundColor: "#ffebee",
    },
  },
  editInput: {
    flex: 1,
    border: "1px solid #579862",
    borderRadius: "4px",
    padding: "4px 8px",
    fontSize: "14px",
    outline: "none",
  },
};

export default GabaritItem;
